import { useI18n } from '@/contexts/i18n-hook';
import type { NivelConfianca, OrigemCampo } from '@/types/apreciacao-ia';

const ESTILO_CONFIANCA: Record<NivelConfianca, string> = {
  alta: 'bg-green-100 text-green-800 border-green-200',
  media: 'bg-amber-100 text-amber-800 border-amber-200',
  baixa: 'bg-red-100 text-red-800 border-red-200',
  ausente: 'bg-gray-100 text-gray-600 border-gray-200',
};

/** Origens determinísticas não precisam de barra de confiança. */
const CHAVE_ORIGEM: Partial<Record<OrigemCampo, string>> = {
  'meta.maquinaId': 'meta.maquinaId',
  'meta.apreciacao': 'meta.apreciacao',
  cronogramaTarefa: 'cronogramaTarefa',
  'ativo.sismana': 'ativo.sismana',
  'ativo.tag': 'ativo.tag',
  'ativo.nome-exato': 'ativo.nomeExato',
  'ativo.nome-fuzzy': 'ativo.nomeFuzzy',
  'maquina.nome': 'maquina.nome',
  'historico-area': 'historicoArea',
  constante: 'constante',
  usuario: 'usuario',
  inferido: 'inferido',
  ausente: 'ausente',
};

export function ConfiancaBadge({
  confianca,
  origem,
}: {
  confianca: NivelConfianca;
  origem?: OrigemCampo;
}) {
  const { t } = useI18n();

  const chaveOrigem = origem ? CHAVE_ORIGEM[origem] : undefined;
  const fonte = chaveOrigem ? t(`apreciacaoIa.origemCampo.${chaveOrigem}`) : undefined;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${ESTILO_CONFIANCA[confianca]}`}
    >
      {t(`apreciacaoIa.confianca.${confianca}`)}
      {fonte && fonte !== '—' && <span className="opacity-70">· {fonte}</span>}
    </span>
  );
}
